import { ref } from '@vue/composition-api';

/**
 * Composable for managing IAPSZ form state and common operations
 * @returns {Object} Form utilities and reactive state
 */
export function useIapszForm() {
  const loading = ref(false);
  const snackbar_saved = ref(false);
  const snackbar_error = ref(false);

  /**
   * Handles successful save operation
   */
  const handleSaveSuccess = () => {
    snackbar_saved.value = true;
  };

  /**
   * Handles save error
   */
  const handleSaveError = () => {
    snackbar_error.value = true;
  };

  /**
   * Sets loading state
   * @param {boolean} state - Loading state
   */
  const setLoading = (state) => {
    loading.value = state;
  };

  return {
    loading,
    snackbar_saved,
    snackbar_error,
    handleSaveSuccess,
    handleSaveError,
    setLoading,
  };
}
